import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";

// project-imports
import LoginFormStencil from "./LoginFormStencil";
import { useUserContext } from "../../context/user_context";
import { toggle_password } from "../../utils";
import SEO from "../../common/SEO";
import Layout from "../../common/Layout";
import BreadcrumbOne from "../../common/breadcrumb/BreadcrumbOne";
import { GoogleAnalyticsEnum, pageView, triggerFunction } from "../../utils/google-analytics";
import Spinner from '../spinner-component/SpinnerOne';


const LoginForm = ({ hideHeader = false, onClose, isFromLogin }) => {

  // React router hook initialization
  const navigate = useNavigate();

  // Extracting methods and variables from context
  const { handleSignIn } = useUserContext();

  // Reading data from store
  const { isLoading, loginData } = useSelector((item) => item.user);

  // State variables
  const [stencilLoading, setStencilLoading] = useState(true);
  const [disableSignInBtn, setDisableSignInBtn] = useState(true);
  const [loginForm, setLoginForm] = useState({
    email: null,
    password: null,
  });
  const [inputValidationErrors, setInputValidationErrors] = useState({
    emailError: true,
    emailErrorText: "",
    passwordError: true,
    passwordErrorText: ""
  });

  setTimeout(() => {
    setStencilLoading(false);
  }, 1000);


  useEffect(() => {
    try {
      if (!hideHeader && loginData && loginData?.data && loginData?.data?.email) {
        const previousPage = document.referrer;

        if (window.history?.length && window.history.length > 1) {
          if (!previousPage) {
            navigate('/', { replace: true });
          } else if (previousPage === "/login" || previousPage === "/register") {
            navigate(-2);
          } else {
            navigate(-1);
          }
        } else {
          navigate('/', { replace: true });
        }
      }
    } catch (error) {
      console.log("73 : LoginForm : Error while redirecting to page :", error && JSON.stringify(error));
    }
  }, [isLoading, loginData]);

  useEffect(() => {
    if (
      !inputValidationErrors.emailError &&
      !inputValidationErrors.passwordError
    ) {
      setDisableSignInBtn(false);
    } else {
      setDisableSignInBtn(true);
    }
  }, [inputValidationErrors]);

  // Constant functions
  const handleChange = (e) => {
    try {
      let name = e.target.name;
      let value = e.target.value;
      let member = loginForm;
      if (name === "email") {
        member.email = value;
      } else if (name === "password") {
        member.password = value;
      }
      setInputValidationErrors((prev) => ({ ...prev, ...validationInput(member, name) }));
      setLoginForm(member);
    } catch (error) {
      console.log("89 : LoginForm : Error while changing input :", error && JSON.stringify(error));
      throw error;
    }
  };
  const validationInput = (member, name) => {
    try {
      let validationState = {};

      if (name === "email") {
        if (member && (!member.email || (member.email && !member.email.length))) {
          validationState.emailError = "Email is required";
        } else {
          validationState.emailError = "";
        }
      }

      if (name === "password") {
        if (member && (!member.password || (member.password && !member.password.length))) {
          validationState.passwordError = "Password is required";
        } else {
          validationState.passwordError = "";
        }
      }

      setInputValidationErrors(validationState);
      return validationState;
    } catch (error) {
      console.log("163 : LoginForm : Error while adding validation :", error && JSON.stringify(error));
      throw error;
    }
  };

  const handleSignInForm = async () => {
    try {
      let formIsValid = true;
      const validationErrros = validationInput(loginForm, "all");
      if (validationErrros.email || validationErrros.password) {
        formIsValid = false;
      }
      if (!disableSignInBtn && formIsValid) {
        await handleSignIn({
          ...loginForm,
        });
        triggerFunction(GoogleAnalyticsEnum.BUTTON, GoogleAnalyticsEnum.LOGIN_SUBMIT_BUTTON);
        onClose && onClose();
      }
    } catch (error) {
      console.log("141: LoginForm : Error while signing in :", error && JSON.stringify(error));
    }
  };

  const loginComponent = () => {
    return (
      <div className="login-form-box">
        {isFromLogin && (
          <>
            <h3 className="text-center mb-0 fs-30">Welcome Back</h3>
            <p className="text-center mb-30 fs-15">Log in to your account to continue.</p>
          </>
        )}
        <form className="p-10">
          <div className="login-form">
            <div className="input-box mb--30">
              <label className="mb-2">
                E-mail/Username
              </label>
              <input
                type="email"
                disabled={isLoading}
                name="email"
                autoFocus
                required
                title="Please Enter Valid Email"
                placeholder="Enter Your Email or Username"
                onChange={handleChange}
                className="fs-15"
              />

              {inputValidationErrors && inputValidationErrors.emailError && (
                <div className="invalid-data">{inputValidationErrors.emailError}</div>
              )}
            </div>
            <div className="input-box mb--10">
              <label className="mb-2">
                Password
              </label>
              <input
                type="password"
                name="password"
                id="password"
                disabled={isLoading}
                placeholder="Enter Your Password"
                required
                autoComplete="false"
                title="Please Enter Valid Password"
                onChange={handleChange}
                className="fs-15"
              />
              {inputValidationErrors && inputValidationErrors.passwordError && (
                <div className="invalid-data">{inputValidationErrors.passwordError}</div>
              )}
            </div>
            <div className="d-flex align-items-center justify-content-between mb--30 ml--10">
              <div className="input-box">
                <input type="checkbox" className="absolute border-0" id="show-password" onClick={toggle_password} />
                <label htmlFor="show-password">Show Password</label>
              </div>
              <Link to={"/forgot-password"} className="fw-bold fs-15">forgot password?</Link>
            </div>

            {/* Adding Spinner icon Start Here */}
            {!isLoading && (
              <button
                disabled={disableSignInBtn}
                className={"rn-btn edu-btn w-100"}
                type="button"
                onClick={handleSignInForm}
              >
                <span>Login</span>
                <i className="icon-arrow-right-line-right"></i>
              </button>
            )}
            {isLoading && (
              <button
                disabled={isLoading}
                className={"rn-btn edu-btn w-100 btn-loading"}
                type="button"
              >
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
                Logging in...
              </button>
            )}
            <div className="block text-center my-3 fs-15">New learner? <Link to={"/register"} className="fw-bold">Create an Account.</Link></div>
            {/* New Added starts */}
          </div>
        </form>
      </div>
    );
  }

  return (
    <>
      {pageView(window.location.pathname, GoogleAnalyticsEnum.LSA_LOGIN_FORM_VIEWED)}
      <div>
        {hideHeader ? <div className="container checkout-page-style pt-3">{loginComponent()}</div> :
          <>
            <SEO title="Longswitch Academy Login form" url="https://longswitchacademy.com/login" />
            {isLoading && <Spinner />}
            <Layout searchDisable={true}>
              <BreadcrumbOne
                title="Login"
                rootUrl="/"
                parentUrl="Home"
                currentUrl="Login"
              />
              <div className="login-register-page-wrapper edu-section-gapBottom pt-5 bg-color-white">
                <div className="container checkout-page-style">
                  <div className="row">
                    <div className="col-lg-6 mx-auto">
                      {stencilLoading ? <LoginFormStencil /> :
                        loginComponent()
                      }
                    </div>
                  </div>
                </div>
              </div>
            </Layout>
          </>
        }
      </div>
    </>
  );
};

export default LoginForm;
